<template lang="pug">
#list.comAll(v-dragDiv,v-show="!actionData.isMini")
  .title.moveDragDiv
    span {{actionData.cnName}}
    i.el-icon-minus.minibtn(title='最小化' @click='miniCom')
    i.el-icon-close(title='关闭' @click='closeAdd')
  .nav
    notationList(ref="notationList" :type="type" @fileaAim="fileaAim" @getPosition="getPosition" )
</template>

<script>
import notationList from "@/views/mongeView/question/notationList.vue";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
export default {
  components: { notationList },
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    },
    type: {
      type: String,
      default() {
        return "";
      }
    }
  },
  methods: {
    miniCom() {
      this.$emit('closeCom', 'list', true);
    },
    closeAdd() {
      this.$emit('closeCom', 'list', false);
    },
    fileaAim(item) {
      const anchorPoint = item.anchorPoint;
      const ifreamBox = this.$parent.$parent.$refs.iframeID;
      const { PDFViewerApplication } = ifreamBox.contentWindow;
      PDFViewerApplication.page = Number(anchorPoint) || 1;
    },
    getPosition(data,quote){
      console.log("getPosition application-----")
      this.$emit("getCommentPosition", data, quote);
    },
    clearAnnotation() {
      mongeApiMlib.clearAnnotation();
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
#list{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 300px;
  .title{
    cursor: auto;
  }
  .nav{
    height: calc(100% - 50px);
    overflow-y: auto;
  }
}
</style>
